<template>
    <v-dialog v-model="show" persistent no-click-animation width="800">
        <div class="ScenarioPermission">
            <div class="dialog-header">
                <div>{{ $f.tc('managePermission') }}</div>
                <v-btn small icon @click="close">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </div>
            <div class="permission-creator">
                <v-form ref="form" v-model="formValid" @submit="submit" class="centerY" style="gap: 8px">
                    <v-text-field
                        outlined
                        :placeholder="$f.tc('email')"
                        :rules="formRules.email"
                        v-model="newUserPermission.userEmail"
                        class="input-custom"
                    ></v-text-field>
                    <div style="width: 230px">
                        <v-select
                            outlined
                            :placeholder="$f.tc('permission')"
                            :items="roleList"
                            v-model="newUserPermission.roleName"
                            :rules="formRules.required"
                            class="input-custom"
                        ></v-select>
                    </div>
                    <div class="btn-outline" @click="grantPermissions">
                        <img
                            src="/img/add-blue.svg"
                            alt="icon-assign-permission"
                            style="transform: scale(1.2); margin-right: 8px"
                        >
                        {{ $f.tc('assign') }}
                    </div>
                </v-form>
            </div>
            <div class="scrollbar-thin table-permission">
                <SimpleDataTable
                    :headers="headers"
                    :items="items"
                >
                    <template v-slot:action="props">
                        <v-btn icon small @click.stop="deleteRole(props.item)">
                            <img src="/img/delete-blue.svg" alt="icon-delete"
                                 style="transform: scale(1.1); padding-left: 1px">
                        </v-btn>
                    </template>
                </SimpleDataTable>
            </div>
        </div>
    </v-dialog>
</template>

<script>
import SimpleDataTable from "@/modules/fptai/components/SimpleDataTable"
import DialogPromiseFormMixin from "@/modules/fptai/mixins/DialogPromiseFormMixin"
import AgentService from "@/services/agent.service";

const userPermissionDefault = {
    userEmail: '',
    roleName: ''
}

export default {
    name: "AgentPermission",
    components: {SimpleDataTable},
    mixins: [DialogPromiseFormMixin],
    data() {
        return {
            agentId: null,
            items: [],
            userEmail: '',
            roleName: 'TESTER',
            newUserPermission: this.$utils.cloneObject(userPermissionDefault),
            roleList: [
                {text: 'ADMIN', value: 'ADMIN'},
                {text: 'EDITOR', value: 'EDITOR'},
                {text: 'TESTER', value: 'TESTER'}
            ]
        }
    },
    computed: {
        headers() {
            return this.$appService.correctHeaders([
                {
                    text: this.$t('name'),
                    value: 'userName'
                }, {
                    text: this.$t('email'),
                    value: 'userEmail'
                }, {
                    text: this.$t('role'),
                    value: 'userRole'
                }, {
                    text: this.$t('action'),
                    value: 'action',
                    type: 'custom',
                    id: 'action'
                }
            ])
        }
    },
    methods: {
        open(agentId) {
            this.show = true
            this.agentId = agentId || this.$route.params.agentId
            this.loadUserPermissions()
            this.clearForm()
            return new Promise((resolve, reject) => {
                this.promise = {resolve, reject}
            })
        },
        loadUserPermissions() {
            AgentService.UserService.search(this.agentId).then(
                result => {
                    this.items = result.data.map(item => ({
                        id: item.id,
                        userName: item.user.name,
                        userEmail: item.user.email,
                        userRole: item.role
                    }))
                }
            )
        },
        deleteRole(item) {
            this.$appService.confirm(
                this.$t('confirmDelete', {item: ': ' + item.userEmail + ' - ' + item.userRole})
            ).then(
                () => {
                    AgentService.UserService.delete(this.agentId, item.id).then(
                        () => {
                            this.loadUserPermissions()
                        },
                        this.$appService.handleRequestError()
                    )
                }
            )
        },
        grantPermissions() {
            AgentService.UserService.create(this.agentId, {
                user: this.newUserPermission.userEmail,
                role: this.newUserPermission.roleName
            }).then(
                () => {
                    this.clearForm()
                    this.loadUserPermissions()
                },
            )
        }
    }
}
</script>

<style scoped lang="scss">
.ScenarioPermission {
    background: #FFFFFF;
    border-radius: 5px !important;
    overflow: hidden;
}

.permission-creator {
    padding: 12px;
    border-bottom: 1px solid #D9D9D9;
}

.table-permission {
    margin: 12px;
    max-height: 600px;
    overflow-y: auto;
}

.input-custom {
    ::v-deep {
        .v-input__slot {
            height: 32px;
            background: #FFFFFF;
            border-radius: 5px;
            border: 1px solid #D9D9D9;
            outline: none;
            font-size: 14px;
            padding: 6px 12px;
            margin: 0;
            display: flex;
            align-items: center;
            position: relative;

            &:before, &:after {
                border: none !important;
            }
        }
    }
}

::v-deep {
    .v-text-field {
        margin-top: 0 !important;
        padding-top: 0 !important;
        position: relative;
    }

    .v-text-field__details {
        position: absolute;
        right: 12px;
        top: 9px
    }

    .v-select {
        .v-input__slot {
            padding: 6px 3px 6px 12px !important;
        }

        .v-text-field__details {
            right: 30px !important;
        }
    }
}
</style>
